import AttendanceByUserType from "./attendance-by-user-type";
import MembersByDemographics from "./members-by-demographics";
import HouseHoldsAgeRange from "./households-age-range";
import TotalDonations from "./total-donations";
import PeopleInCHMS from "./people-in-chms";
import VolunteerGaps from "./volunteer-gaps";
import ServingInterests from "./serving-interests";
import EngagementLevel from "./engagement-level";
import AttendanceLevel from "./attendance-level";

const InsightsOverview = () => {
    return (
        <>
            <div className="flex gap-4 mt-5 flex-wrap">
                <AttendanceByUserType/>
                <MembersByDemographics/>
                <HouseHoldsAgeRange/>
            </div>

            <div className="flex gap-4 mt-4 flex-wrap">
                <TotalDonations/>
                <PeopleInCHMS/>
            </div>

            <div className="flex gap-4 mt-4 flex-wrap">
                <ServingInterests/>
                {/* <TotalDonations/> */}
                

                <VolunteerGaps/>
            </div>

            <div className="flex gap-4 mt-4 flex-wrap">
                <EngagementLevel/>
                <AttendanceLevel/>
            </div>
        </>
    )
}

export default InsightsOverview;
